import React, { FC, useState } from 'react';
import { ChatMessages } from '@src/components/ChatMessages';
import { MessageEntryArea } from '@src/containers/MessageEntryArea';
import { parseEmojis, emojiRegexp } from '@src/util/parseEmojis';
import { MetricContext } from '@src/metrics/metrics.enum';
import { ChatHeader } from './ChatHeader';
import { ChatProps } from './props';
import { ClosedChatMessageSection } from '@src/components/ClosedChatMessageSection';
import './styles.scss';

export const Chat: FC<ChatProps> = ({
  doesUserVerificationProfileExist,
  messageThread,
  onAccept,
  onClose,
  onDecline,
  onInputChange,
  onReopen,
  sendMessage,
  typedMessage,
}) => {
  const [isSending, setIsSending] = useState(false);

  const user = messageThread?.user;
  const countryCode = user?.phone?.country?.dialCode;
  const phoneNumber = user?.phone?.number;
  const userPhone = countryCode && phoneNumber ? `+${countryCode} ${phoneNumber}` : undefined;

  const submitMessage = () => {
    const regexp = new RegExp(` (${emojiRegexp})$`);
    const message = parseEmojis(typedMessage, regexp);

    setIsSending(true);

    sendMessage(message)
      .then(() => {
        setIsSending(false);
      })
      .catch(() => {
        setIsSending(false);
      });
  };

  const handleAccept = (): void => {
    onAccept(messageThread, typedMessage);
  };

  const handleDecline = (): void => {
    onDecline(messageThread, typedMessage);
  };

  const handleReopen = (): void => {
    onReopen(messageThread, typedMessage);
  };

  const handleOnClose = (): void => {
    onClose(messageThread, typedMessage);
  };

  const isDisabled = isSending || !typedMessage.trim().length;

  return (
    <div className="inbox-chat">
      {messageThread.opening && (
        <ChatHeader
          doesUserVerificationProfileExist={doesUserVerificationProfileExist}
          opening={messageThread.opening}
        />
      )}

      {messageThread.messages && (
        <ChatMessages
          messages={messageThread.messages.result}
          opening={messageThread.opening || undefined}
          user={messageThread.user}
        />
      )}

      {user?.state !== 'draft' ? (
        <MessageEntryArea
          isDisabled={ isDisabled }
          message={ typedMessage }
          messageThread={ messageThread }
          metricsContext={ MetricContext.CHATS }
          onAccept={ handleAccept }
          onChange={ onInputChange }
          onClose={ handleOnClose }
          onReject={ handleDecline }
          onReopen={ handleReopen }
          onSend={ submitMessage }
        />
      ) : (
        <ClosedChatMessageSection
          email={ user.email || undefined }
          phone={ userPhone }
          userName={ user.name || undefined }
        />
      )}
    </div>
  );
};
